import { render, staticRenderFns } from "./journalEntries.vue?vue&type=template&id=2231f664&scoped=true&"
import script from "./journalEntries.vue?vue&type=script&lang=js&"
export * from "./journalEntries.vue?vue&type=script&lang=js&"
import style0 from "./journalEntries.vue?vue&type=style&index=0&id=2231f664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231f664",
  null
  
)

export default component.exports